import styled from "styled-components"
import { Row, Col, Accordion } from "react-bootstrap";
import { BPSAccordionStyled } from "../styled/BPSAccordion";

import '../Backgrounds/Backgrounds.css';

import DetailedReporting from '../../assets/images/Rebates - Detailed Analytics.png';
import EfficientValidation from '../../assets/images/Rebates - Pending Claims.png';
import Security from '../../assets/images/Rebates - Top Security.png';
import Communication from '../../assets/images/Rebates - Engaging Communication.png';

import { BPSCheckmarkList, Checkmark } from "../styled/Lists";


const RebateAccordion = () => {
    return (
        <BPSAccordionStyled>
            <Accordion defaultActiveKey="0" >
                <Row className="justify-content-evenly">
                    <Col md={6} className="order-2 order-md-1">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Detailed reporting & analytics</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Our intuitive dashboards present essential metrics at a glance. With our robust reporting tools, you’ll get in-depth insights that allow you to:
                                </p>
                                <BPSCheckmarkList>
                                    <ul>
                                        <li>
                                            <Checkmark />Spot trends.
                                        </li>
                                        <li>
                                            <Checkmark />Track program progress.
                                        </li>
                                        <li>
                                            <Checkmark />Refine strategies for optimal success.
                                        </li>
                                    </ul>
                                </BPSCheckmarkList>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Efficient validation process</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Speed and accuracy are of the essence. Our state-of-the-art validation technology ensures that rebate claims are processed swiftly and accurately, enhancing customer satisfaction and trust.
                                </p>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Top-tier security protocols</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Protecting customer data is our top priority. With advanced security features, we ensure that participant data is safeguarded at all times.
                                </p>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>Engaging communication</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Keep your program top of mind. Our program emails and marketing messages are designed to engage customers effectively, ensuring consistent participation.
                                </p>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Col>

                    <Col md={5} sm={8} className="order-1 order-md-2">
                        <Accordion.Item eventKey="0">
                            <Accordion.Body>
                                <img src={DetailedReporting} width='100%' />
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Body>
                                <img src={EfficientValidation} width='100%' />
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Body>
                                <img src={Security} width='100%' />
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Body>
                                <img src={Communication} width='100%' />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Col>
                </Row>
            </Accordion>
        </BPSAccordionStyled>
    );
}


export { RebateAccordion }
